import { RouteConstantsInterface } from './types';

export enum EmailRedirectedRoutes {
  SIGNUP = 'signup',
  VERIFY = 'verify-user',
  RESET_PASSWORD = 'reset-password',
}

export enum RouteConstantEnums {
  //LOGIN

  LOGIN,
  SIGNUP,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
  VERIFY_USER,

  // VIEW ROUTES
  HOME,
  NOT_FOUND,
  UNAUTHORIZED_ACCESS,

  //Pricing Routes
  PRICING,
  LIVE_PRICING,
  SUGGESTED_PRICING,
  BUNDLE_SUGGESTED_PRICING,
  BUNDLE_LIVE_PRICING,
  CBP_SUGGESTION_LISTING,
  REJECTED_BATCHES,
  HISTORICAL_PRICING,
  CAMPAIGN_SUGGESTIONS,

  CAMPAIGNS,
  YEARLY_CAMPAIGNS,
  DAILY_CAMPAIGNS,
  COUPONS,
  RECEIVABLES,
  SEGMENT,
  SKU,
  EXPERIMENTS,
  REPORTS,
  ASN,
  PO,
  PO_SUMMARY,
  BULK_PO_CREATION,
  PO_SUMMARY_ID,
  USER_MANAGEMENT,
  PRICING_SUMMARY,
  UPLOAD_PRICING,
  APPROVALS,
  BULK_JOBS,
  BULK_REPORTS,

  PO_APPROVAL,
  RETURN_PO_ACKNOWLEDGEMENT,
}

export const RouteConstants: RouteConstantsInterface = {
  HOME: '/',
  NOT_FOUND: '*',
  UNAUTHORIZED_ACCESS: '/unauthorized-access',

  LOGIN: '/login',
  SIGNUP: '/signup',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  VERIFY_USER: '/verify-user',

  //PRICING MODULES START
  PRICING: '/pricing',
  LIVE_PRICING: '/pricing/live',
  SUGGESTED_PRICING: '/pricing/suggested',
  BUNDLE_SUGGESTED_PRICING: '/pricing/bundle-suggested',
  BUNDLE_LIVE_PRICING: '/pricing/bundle-live',
  CBP_SUGGESTION_LISTING: '/pricing/cbp-suggested',
  REJECTED_BATCHES: '/pricing/rejected-batches',
  HISTORICAL_PRICING: '/pricing/historical-pricing',
  CAMPAIGN_SUGGESTIONS: '/pricing/campaign-suggestions',

  //PRICING MODULES END

  CAMPAIGNS: '/campaigns',
  YEARLY_CAMPAIGNS: '/campaigns/yearly',
  DAILY_CAMPAIGNS: '/campaigns/daily',
  COUPONS: '/coupons',
  RECEIVABLES: '/receivables',
  SEGMENT: '/segment',
  SKU: '/sku',
  EXPERIMENTS: '/experiments',
  REPORTS: '/reports',
  ASN: '/asn',
  PO: '/po',
  PO_SUMMARY: '/po/summary',
  PO_SUMMARY_ID: '/po/summary/:id',
  BULK_PO_CREATION: '/po/bulk-creation',
  USER_MANAGEMENT: '/users',
  PRICING_SUMMARY: '/margin-summary',
  UPLOAD_PRICING: '/upload-margin',
  APPROVALS: '/approvals',
  BULK_JOBS: '/po/bulk-jobs',
  BULK_REPORTS: '/po/bulk-reports',

  PO_APPROVAL: '/po-approval',
  RETURN_PO_ACKNOWLEDGEMENT: '/return-po-acknowledgement',
};
